import React from "react";

const ComplaintCommittee = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Internal Complaint Committee</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <h6>HARYANA SEEDS DEVELOPMENT CORPORATION LIMITED</h6>

        <p>(A STATE GOVT. UNDERTAKING)</p>

        <p>BEEJ BHAWAN, BAYS 3-6, SECTOR-2, PANCHKULA</p>

        <p>
          Members of The Internal Complaint Committee for Head Office and all
          units i.e. Umri, Hisar, Sirsa, Tohana, Pataudi, Yamuna Nagar and
          Bhiwani under Sexual Harassment of Women at Workplace. (Prevention
          Prohibition and Redressal) Act,2013 :-
        </p>
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <th>Sr. No.</th>
                <th>Name of the officer/official</th>
                <th>Designation</th>
                <th>Email</th>
                <th>Mobile No.</th>
              </tr>
              <tr>
                <td>1</td>
                <td>Mrs. Archana Sood Company Secretary</td>
                <td>Presiding Officer</td>
                <td>cshsdcl@gmail.com</td>
                <td>0172-2567172</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Smt. Kamal Kuttapan (HCS Retd.)</td>
                <td>Member</td>
                <td>bgms.pklhsb@gmail.com</td>
                <td>0172-2569079</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Sh. Arun Chowdhary, A.O.</td>
                <td>Member</td>
                <td>aohsdcl@gmail.com</td>
                <td>94170-41343</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Sh. Anil Kumar, A.E</td>
                <td>Member</td>
                <td>jehsdcl@gmail.com</td>
                <td>98723-77544</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Mrs. Jeevan Rani, Section Officer</td>
                <td>Member</td>
                <td>jeewanshergill@gmail.com</td>
                <td>99888-21054</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ComplaintCommittee;
